import { render, staticRenderFns } from "./VideoCallRoom.vue?vue&type=template&id=4bdf605d&scoped=true&"
import script from "./VideoCallRoom.vue?vue&type=script&lang=ts&"
export * from "./VideoCallRoom.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdf605d",
  null
  
)

export default component.exports